/** Angular edit: `showMap` is set by `refreshMap('LatLong'|undefined)`, including load when lat/lng are missing. */
export function hasSavedLatLng(latitude: unknown, longitude: unknown): boolean {
  if (latitude == null || longitude == null) return false
  const lat = String(latitude).trim()
  const lng = String(longitude).trim()
  if (!lat || !lng) return false
  return Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))
}

/** True when edit load should show the map (Angular `refreshMap()` path). */
export function shouldShowMapOnEditLoad(latitude: unknown, longitude: unknown): boolean {
  return !hasSavedLatLng(latitude, longitude)
}
